export default __webpack_public_path__ + "static/media/success.ade0872b.svg";